module.exports = "/assets/eagle.png";